import { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
// @mui
import { Stack, IconButton, InputAdornment, TextField } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import profile from 'src/store/profile';
import api from 'src/utils/api';
// components
import Iconify from '../../../components/iconify';

// ----------------------------------------------------------------------

export default function LoginForm() {
  const navigate = useNavigate();
  const passwordRef = useRef(null);
  
  const [showPassword, setShowPassword] = useState(false);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleClick = () => {
    if (username !== '' && password !== '')
      api.post('auth/login', { username, password })
        .then((result) => {
          if (result.status === "success") {
            profile.setTeacherRole();
            profile.login(result.data);
            navigate('/teacher/calendar');
          } else if (result.status === "error") {
            setError(result.message);
          }
        })
        .catch((err) => {
          api.logError('login failed', err);
          setError('true');
        });
    else setError('true');
  };

  return (
    <>
        <Stack spacing={3}>

          <TextField name="username" label="Логін" value={username} error={Boolean(error)}
            onChange={(event) => {
              setUsername(event.target.value);
            }}
            onKeyDown={(event) => {
              if (event.key === 'Enter') {
                passwordRef.current?.focus();
              }
            }} />

          <TextField
            name="password"
            label="Пароль"
            type={showPassword ? 'text' : 'password'} error={Boolean(error)}
            helperText={"Неправильний логін або пароль"}
            value={password}
            onChange={(event) => {
              setPassword(event.target.value);
            }}
            inputRef={passwordRef}
            onKeyDown={(event) => {
              if (event.key === 'Enter') {
                handleClick();
              }
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                    <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Stack>

        <Stack direction="row" alignItems="center" justifyContent="flex-end" sx={{ my: 2 }} />

        <LoadingButton fullWidth size="large" type="submit" variant="contained" onClick={handleClick}>
          Увійти
        </LoadingButton>
        
    </>
  );
}
